import GTM from '../../gtm/GTM';
import GTMSignUpModel from '../../gtm/models/GTMSignUpModel';

export default abstract class TrackSignUp {
    public static trackSignUpEvent(): void {
        if (!this.#isSignUpEventFinished()) {
            return;
        }

        GTM.track(GTMSignUpModel.parseToGTMData());
    }

    static #isSignUpEventFinished(): boolean {
        const meta = document.querySelector<HTMLMetaElement>('meta[name="registration_method"]');

        return Boolean(meta?.getAttribute('content'));
    }
}
